/* ===========================================================================
   Navigation menu
   =========================================================================== */

import {onClickOutside} from '@vueuse/core';

const navigation = document.querySelector('.navigation');
const menuItems = navigation.querySelectorAll('[href^="#"]');
menuItems.forEach(menuItem => {
    const listItem = menuItem.parentElement;
    menuItem.addEventListener('click', event => {
        event.preventDefault();
        toggle(menuItem);
    });
    onClickOutside(listItem, () => toggle(menuItem, false));
});

function toggle(menuItem, force) {
    const submenu = menuItem.nextElementSibling;
    const listItem = menuItem.parentElement;
    listItem.classList.toggle('menu-item-active', force);
    submenu.classList.toggle('menu-active', force);
}

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('#js-header');
    const menuOffCanvas = document.querySelector('#menu-off-canvas');
    const menuButton = document.querySelector('[data-toggle="menu-off-canvas"]');
    menuButton.addEventListener('click', () => menuOffCanvas.style.top = header.clientHeight + 'px');
});
